/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Divisions_NInputs */

const th_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} รุ่น`)
};

const en_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} divisions`)
};

const ja_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 部門`)
};

const zh_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个分区`)
};

const es_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} categorías`)
};

const pt_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} categorias`)
};

const id_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} divisi`)
};

const fr_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} catégories`)
};

const tl_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dibisyon`)
};

const vi_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} bảng`)
};

const ko_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}개 디비전`)
};

const de_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Klassen`)
};

const ru_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Дивизионов: ${i?.count}`)
};

const tr_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} grup`)
};

const it_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} categorie`)
};

const pl_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grup: ${i?.count}`)
};

const uk_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Дивізіонів: ${i?.count}`)
};

const hi_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} वर्ग`)
};

const ar_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} فئات`)
};

const ms_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} divisyen`)
};

const bn_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}টি বিভাগ`)
};

const zh_tw2_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 個分組`)
};

const zh_hk2_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 個組別`)
};

const ur_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} درجے`)
};

const fa_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} گروه`)
};

const sw_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Madaraja ${i?.count}`)
};

const nl_divisions_n = /** @type {(inputs: Divisions_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} klassen`)
};

/**
* | output |
* | --- |
* | "{count} divisions" |
*
* @param {Divisions_NInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const divisions_n = /** @type {((inputs: Divisions_NInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Divisions_NInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_divisions_n(inputs)
	if (locale === "ja") return ja_divisions_n(inputs)
	if (locale === "zh") return zh_divisions_n(inputs)
	if (locale === "es") return es_divisions_n(inputs)
	if (locale === "pt") return pt_divisions_n(inputs)
	if (locale === "id") return id_divisions_n(inputs)
	if (locale === "fr") return fr_divisions_n(inputs)
	if (locale === "tl") return tl_divisions_n(inputs)
	if (locale === "vi") return vi_divisions_n(inputs)
	if (locale === "ko") return ko_divisions_n(inputs)
	if (locale === "de") return de_divisions_n(inputs)
	if (locale === "ru") return ru_divisions_n(inputs)
	if (locale === "tr") return tr_divisions_n(inputs)
	if (locale === "it") return it_divisions_n(inputs)
	if (locale === "pl") return pl_divisions_n(inputs)
	if (locale === "uk") return uk_divisions_n(inputs)
	if (locale === "hi") return hi_divisions_n(inputs)
	if (locale === "ar") return ar_divisions_n(inputs)
	if (locale === "ms") return ms_divisions_n(inputs)
	if (locale === "bn") return bn_divisions_n(inputs)
	if (locale === "zh-TW") return zh_tw2_divisions_n(inputs)
	if (locale === "zh-HK") return zh_hk2_divisions_n(inputs)
	if (locale === "ur") return ur_divisions_n(inputs)
	if (locale === "fa") return fa_divisions_n(inputs)
	if (locale === "sw") return sw_divisions_n(inputs)
	if (locale === "nl") return nl_divisions_n(inputs)
	return en_divisions_n(inputs)
});